export const QUERY = `
mutation JWMCalendarUpdateDates($input: JWMScheduleTimelineItemInput!) {
  scheduleTimelineJwmItem(input: $input) {
    success
    errors {
      message
      extensions {
        statusCode
        errorType
      }
    }
  }
}`;
